import React, {Component} from "react";
import FadeIn from 'react-fade-in';

class Testimonials  extends Component {

	pageContent(title) {
		
		return(
		<div className="arrival">
			<div className="container sj-container ">
		      		      
		        <h1 className="font-weight-light">{title}</h1>
		        
		        <div className="row align-items-center">
		        	<div className="col-lg-12 col-sm-12">
			        <p className="dt-text-large text-center">See what clients are saying about their 
			        experience with Diane Taylor at MFT Associate.
			        </p>
					<p className="text-center">
					Hear from real clients about the impact Diane Taylor 
					has made on their lives.
					</p>		        
		        	</div>
		   		 </div>
		        
		     
		    	<FadeIn
					delay={global.config.fadein.delay}
					transitionDuration={global.config.fadein.duration}
					> 
	          	
		          	<div className="col-lg-12">
		          		<hr />
		          	</div>
	          	
			    	<div className="row align-items-center my-5">
						<div className="col-lg-12 col-sm-12 d-flex justify-content-center">      
				          
					        <div class="toast show">
							  <div class="toast-header">
							    Sarah M.
							  </div>
							  <div class="toast-body">
							    Diane has been an incredible support through 
						        one of the most challenging times in my life. 
						        Her compassionate and insightful approach made 
						        me feel understood and empowered to make positive changes. 
						        I can’t recommend her enough!
							  </div>
							</div>
							
						</div>
					</div>
	
					<div className="row align-items-center my-5">
						<div className="col-lg-12 col-sm-12 d-flex justify-content-center">      
				          
					        <div class="toast show">
							  <div class="toast-header">
							    James & Emily T.
							  </div>
							  <div class="toast-body">
							    Working with Diane has been a game-changer for our relationship. 
							    She helped us improve our communication and rebuild trust. 
							    We’re now stronger and more connected than ever.
							  </div>
							</div>
							
						</div>
					</div>
					<div className="row align-items-center my-5">
						<div className="col-lg-12 col-sm-12 d-flex justify-content-center">      
				          
					        <div class="toast show">
							  <div class="toast-header">
							    Mark L.
							  </div>
							  <div class="toast-body">
							    Diane creates such a safe and welcoming space. 
							    Her ability to listen without judgment and provide 
							    practical tools has been invaluable in managing my 
							    anxiety. I’m so grateful for her guidance!
							  </div>
							</div>
							
						</div>
					</div>
			  		<div className="row align-items-center my-5">
						<div className="col-lg-12 col-sm-12 d-flex justify-content-center">      
				          
					        <div class="toast show">
							  <div class="toast-header">
							    Nicola T.
							  </div>
							  <div class="toast-body">
							    Diane is a great therapist! Rather for your 
							    teen or yourself. She is very flexible 
							    so go check her out, she has you covered! 
							    My daughter and I have been going to her for 
							    over 2 years. We're thankful to have her!
							  </div>
							</div>
							
						</div>
					</div>
			  		<div className="row align-items-center my-5">
						<div className="col-lg-12 col-sm-12 d-flex justify-content-center">      
				          
					        <div class="toast show">
							  <div class="toast-header">
							    Davena V.
							  </div>
							  <div class="toast-body">
							    Diane Taylor is not only a dedicated 
							    family therapist, but she us also a 
							    caring and compassionate person! Love her!!
							  </div>
							</div>
							
						</div>
					</div>		  		
			  		<div className="row align-items-center my-5">
						<div className="col-lg-12 col-sm-12 d-flex justify-content-center">      
				          
					        <div class="toast show">
							  <div class="toast-header">
							    Austin H.
							  </div>
							  <div class="toast-body">
							    Diane Taylor is an exceptional family 
							    therapist who truly cares about her clients. 
							    She creates a warm, welcoming environment where 
							    open communication and healing can take place. 
							    Her guidance has helped our family navigate 
							    challenges with greater understanding and 
							    compassion. Diane’s expertise, patience, 
							    and thoughtful approach have made a significant 
							    positive impact on our relationships. I highly 
							    recommend anyone in the Louisville area who is 
							    seeking professional and effective family therapy!
							  </div>
							</div>
							
						</div>
					</div>	
			  		
			  		
			  				  		
		    </FadeIn>
			</div>
		</div>
		);
	}

    render() {
			
		document.title = global.config.pageTitles.testimonials + 
							global.config.pageTitles.seperator +
							global.config.pageTitles.title;	
			
		let title = global.config.pageTitles.testimonials;

        return (
            this.pageContent(title)
        );
        
    }

}

export default Testimonials;

    
